export default "__VITE_PUBLIC_ASSET__108b1bcb__"